module.exports = __webpack_public_path__ + "img/teca-logo.f8c28c3b.png";